import React from 'react';

import classes from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateForm/CreateReportFromTemplateForm.module.scss';
import { NewReportName } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateForm/components/NewReportName/NewReportName';
import { ProjectContractSelection } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateForm/components/ProjectContractSelection/ProjectContractSelection';
import { SelectingTags } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateForm/components/SelectingTags/SelectingTags';
import { UseCreateReportFromTemplateModalLogic } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateModal.logic';
import { UseCreateReportFromTemplateModalProvider } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateModal.provider';

interface Props {
    logic: UseCreateReportFromTemplateModalLogic['logic'];
    api: UseCreateReportFromTemplateModalProvider['api'];
}

export const CreateReportFromTemplateForm = ({ logic, api }: Props) => {
    return (
        <div className={classes.createReportFromTemplateModalContainer}>
            <form className={classes.formSection} onSubmit={logic.form.handleSubmit(logic.handleSubmitForm)}>
                <ProjectContractSelection api={api} logic={logic} />
                <NewReportName logic={logic} />
                <SelectingTags logic={logic} />
            </form>
        </div>
    );
};
